import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { getLottieConfig } from 'src/app/core/constants/app-constants';
import { AudioPlayerService } from "../../services/audio-player.service";

@Component({
  selector: 'app-coupon-confirmation-modal',
  templateUrl: './coupon-confirmation-modal.component.html',
  styleUrls: ['./coupon-confirmation-modal.component.scss'],
})
export class CouponConfirmationModalComponent implements OnInit {

  @Input() modalObj: any;
  scratchWonConfig = getLottieConfig("SCRATCH_WON_CONFIG");

  constructor(public activeModal: NgbActiveModal, private audioService: AudioPlayerService) { }

  ngOnInit() {
    console.log("called to check", this.modalObj);
    this.audioService.play();
    setTimeout(() => {
      this.activeModal.close();
    }, 2000);
  }

}
